import React from 'react';
import { connect } from 'react-redux';
import { Container, Alert } from 'reactstrap';

import { ApplicationState } from 'store/redux';
import * as AlertStore from 'store/redux/Alerts';
import './NavMenu.css';

export type IAlertsProps = {
  alert: AlertStore.Alert;
};

const Alerts = function ({ alert }: IAlertsProps) {
  return (
    <Container>
      <Alert color={alert.AlertType} isOpen={true}>
        {alert.Message}
      </Alert>
    </Container>
  );
};

export default connect((appState: ApplicationState) => ({ alert: appState.alert }))(Alerts);
